export class TablePositionStatus {
    paginatorPos: string;
    isPaginatorEvent: boolean = false;
    sortField: string;
    sortDirection: string;
}